import { featured } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const toneMap: Record<string, { chip: string; bar: string }> = {
  crimson: { chip: "bg-primary-100 text-primary-800", bar: "bg-primary-500" },
  gold: { chip: "bg-accent-100 text-accent-900", bar: "bg-accent-500" },
  ink: { chip: "bg-secondary-200 text-secondary-900", bar: "bg-secondary-700" },
};

export default function FeaturedZone() {
  return (
    <section className="w-full bg-background-100/60">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading index="02" title="专题深挖" note="不只是标题，把来龙去脉讲清楚" onMore={() => {}} />
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((f, i) => {
            const t = toneMap[f.tone] ?? toneMap.ink;
            return (
              <article
                key={i}
                className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="relative aspect-[9/6] w-full overflow-hidden bg-background-100">
                  <img
                    src={f.image}
                    alt={`看黑料 ${f.tag} 专题配图`}
                    title={`看黑料 ${f.tag}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className={`absolute left-3 top-3 whitespace-nowrap rounded-sm px-2 py-1 text-xs font-medium ${t.chip}`}>
                    {f.tag}
                  </span>
                </div>
                <div className="relative flex flex-1 flex-col p-4 md:p-5">
                  <span className={`absolute left-0 top-0 h-0.5 w-10 ${t.bar}`} />
                  <h3 className="mt-1 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {f.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{f.summary}</p>
                  <div className="mt-4 flex items-center justify-between gap-2 border-t border-background-200 pt-3">
                    <span className="text-xs text-foreground-400">{f.meta}</span>
                    <span className="flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600">
                      继续深挖
                      <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}